import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { findLatestDocumentVersion } from "../../../api/content/sourcesApi";
import { useLoad } from "../../../shared/loading/useLoad";
import type { DocumentVersionRef } from "../../../shared/references/contentReferences";
import Chip from "../../../ui/feedback/Chip";

/**
 * Whether the open version is its document's latest, by the server's one answer: "Latest version"
 * or "Older version", never its hash (F77; IM-RULES "Readable versions"). The corpus's release is
 * the Documents sidebar's (LatestCorpusVersion), so it isn't repeated here. Nothing until the
 * latest is known. Its caller keys it by the corpus's latest version, so a new one is asked again.
 */
export default function DocumentVersionLabel({ reference }: { reference: DocumentVersionRef }) {
  const { t } = useTranslation();
  const { documentId, version } = reference;
  const load = useCallback((signal: AbortSignal) => findLatestDocumentVersion(documentId, signal), [documentId]);
  const { state: latest } = useLoad(load);
  if (latest.status !== "loaded") return null;
  return <Chip size="regular">{t(latest.value.version === version ? "sources.corpus.latest" : "sources.document.olderVersion")}</Chip>;
}
